import { combineReducers } from 'redux'
import { documentInstancesReducers } from './documentInstances'
import { documentTemplatesReducers } from './documentTemplates'
import { filesReducers } from './files'
import { CacheState } from './cache.model'
import { userMeTeamsReducers } from './users'
import { questionInstancesReducers } from './questionInstances'
import { medicalEventsReducers } from './medicalEvents'
import { resourceHistoryReducers } from './resourceHistory'

export default combineReducers<CacheState>({
  documentInstances: documentInstancesReducers,
  documentTemplates: documentTemplatesReducers,
  files: filesReducers,
  medicalEvents: medicalEventsReducers,
  questions: questionInstancesReducers,
  resourceHistory: resourceHistoryReducers,
  userMeTeams: userMeTeamsReducers,
})
